import React, { useEffect, useState } from 'react';
import {
    BrowserRouter as Router,
    Routes,
    Route
} from 'react-router-dom';
import './index.css';
import Home from './components/Home';
import Results from './components/Results';
import Plans from './components/Plans';
import About from './components/About';
import LoadingAni from './components/LoadingAni';

const App = () => {

    const [isLoading, setIsLoading] = useState(true);
    

     useEffect(() => {
        // Simulate data fetching or other asynchronous tasks
        setTimeout(() => {
         // In a real application, you would fetch data here
        
        setIsLoading(false); // Set loading to false once data is ready
        }, 3000); // Simulate a 3-second loading time
    }, []);


    return (
        
        <Router>
            <div>
                {isLoading ? (
                    <LoadingAni /> // Show the loading spinner while loading
                ) : (
                    
                    <Routes>
                        <Route path="/" element={<Home />} />
                        <Route path="/results" element={<Results />} />
                        <Route path="/plans" element={<Plans />} />
                        <Route path="/about" element={<About />} />
                    </Routes>
                )}
            </div>
            
        </Router>
        
    );
}

export default App;
